import { useState } from "react";
import { Modal } from "risa-oasis-ui_v2";
import { CmmOrderTableRowData } from "../../../../data-model/cmmOrderTableRowData";
import { ModalId } from "../../../../enums/modalId";
import { CopyIcon } from "../../../../svg/copy-icon";
import { calculateAge } from "../../../../utils/ageCalculator";
import SideNavElement from "../../../sideNavElement/sideNavElement";
import Dosage from "./components/dosage";
import DosageThinking from "./components/dosageThinking";

interface ExpandableTableRowDosageProps {
  onClose: () => void;
  rowData?: CmmOrderTableRowData;
}

const tabs = [
  { id: "prescription", label: "Prescription" },
  { id: "dosage-thinking", label: "Dosage Thinking" },
];

const ExpandableTableRowDosage = ({
  onClose,
  rowData,
}: ExpandableTableRowDosageProps) => {
  const [selectedTab, setSelectedTab] = useState<string>("prescription");

  const renderContent = () => {
    switch (selectedTab) {
      case "prescription":
        return <Dosage rowData={rowData ?? ({} as CmmOrderTableRowData)} />;
      case "dosage-thinking":
        return (
          <DosageThinking rowData={rowData ?? ({} as CmmOrderTableRowData)} />
        );
      default:
        return null;
    }
  };

  return (
    <Modal
      dialogId={ModalId.EXPANDABLE_TABLE_ROW_DOSAGE_MODAL}
      onSave={onClose}
      title={"Dosage"}
      saveButtonText={"Close"}
      cancelText={"Cancel"}
      onCancel={onClose}
      onClose={onClose}
      heightPercentage={90}
      showSingleButton={true}
      hideFooter={true}
    >
      <div className="flex h-full flex-col">
        <div className="flex w-full items-center gap-2 border-b border-primaryGray-15 pb-3">
          <div className="mx-2 rounded-[1.875rem] bg-primaryGray-16 px-4 py-1 text-small font-semibold leading-6 text-primaryGray-1">
            {rowData?.patientDetails?.mainText ?? "--"}
            &nbsp;&nbsp;<span>&#8226;</span>&nbsp;&nbsp;
            {rowData?.patientId ?? "--"}
            &nbsp;&nbsp;<span>&#8226;</span>&nbsp;&nbsp;
            {rowData?.dateOfBirth?.mainText ?? "--"} (
            {calculateAge(rowData?.dateOfBirth?.mainText)} yrs) &nbsp;&nbsp;
            <span>&#8226;</span>&nbsp;&nbsp;
            {rowData?.medication?.split(" ")[0] ?? "--"}
          </div>
          <div className="rounded-[1.875rem] bg-primaryGray-16 px-4 py-1 text-small font-semibold leading-6 text-primaryGray-1">
            {rowData?.type ?? "--"}
          </div>
          <div className="cmm-result-key mx-2 ml-auto flex items-center gap-2 text-small">
            CMM Key:{" "}
            <span className="font-bold">
              {rowData?.cmmKey ?? "--"}
              &nbsp;
            </span>
            <div
              className="cmm-result-key copy-icon hover:cursor-pointer"
              onClick={() => {
                navigator.clipboard.writeText(rowData?.cmmKey ?? "");
              }}
            >
              <CopyIcon />
            </div>
          </div>
        </div>

        <div className="flex flex-1 gap-1 overflow-hidden">
          <div className="side-nav--container flex w-[25%] flex-col overflow-y-auto">
            {tabs.map((tab) => (
              <SideNavElement
                key={tab.id}
                id={tab.id}
                label={tab.label}
                active={tab.id === selectedTab}
                onSelect={(id) => setSelectedTab(id)}
              />
            ))}
          </div>
          <div className="content--container flex h-full w-[75%] flex-1 flex-col bg-primaryGray-16 pb-3">
            {renderContent()}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ExpandableTableRowDosage;
